import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../../../common/widgets/Button';
import Dialog from '../../../../../../common/widgets/Dialog';
import { rewriteImageUrl } from '../../../../helpers';
import { EmployeeCardItemModel } from '../../../../models/Cards';
import { resources } from '../../../../resources/resources';

interface DisableCardDialogProps {
  closeDialog: () => void;
  card: EmployeeCardItemModel;
}

export const ReissueCardDialog = (props: DisableCardDialogProps) => {
  const { card, closeDialog } = props;
  const { t: translate } = useTranslation();
  const navigate = useNavigate();

  return (
    <Dialog
      closeDialog={closeDialog}
      showCloseIcon
      closeOnClickOutside
      className="dialog-m block-card-dialog"
    >
      <div className="dialog-content">
        <div className="dialog-image">
          <img src={rewriteImageUrl(card.mainImage, 122, 196)} />
        </div>
        <div className="dialog-title">
          {translate(resources.employeeCards.reissueDialog.title)}
        </div>
        <div
          className="dialog-text"
          dangerouslySetInnerHTML={{
            __html: translate(
              resources.employeeCards.reissueDialog.warningBody,
            ),
          }}
        />
      </div>
      <div className="dialog-actions horizontal">
        <Button onClick={closeDialog} className="btn btn-outline">
          {translate(resources.cancel)}
        </Button>
        <Button
          onClick={() =>
            navigate('/my-account/cards/reissue', { state: { card } })
          }
          className="btn btn-solid"
        >
          {translate(resources.continue)}
        </Button>
      </div>
    </Dialog>
  );
};
